import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";
import Working from "../../shared_comp/Working";
import useToc from "../../hooks/useToc";
import { BookInfo, LawInfo } from "../../config/types";
import { Box, Button, Card, Text, TextInput } from "grommet";
import { Close, Search } from "grommet-icons";

const LawMain = () => {
    const [lawList, setLawList] = React.useState<LawInfo[]>([]);
    const [lawReady, setLawReady] = React.useState(false);
    const [bookList, setBookList] = React.useState<BookInfo[]>([]);
    const [sortFinished, setSortFinished] = React.useState(false);

    React.useEffect(() => {
        const resBooks = async () => {
            let resB = await useBook.getBookList("official report");
            console.log("book", resB);
            if (resB.result) {
                setBookList(resB.books);
            }
        };
        resBooks();
    }, []);
    React.useEffect(() => {
        const tocSearchKey = ["府令 第"];
        setLawReady(false);
        setSortFinished(false);
        if (bookList.length > 0) {
            const resTocs = async () => {
                let resT = await useToc.getTocSearch(tocSearchKey);
                console.log("toc", resT);
                // decompose usernote
                let laws: LawInfo[] = [];
                if (resT.result) {
                    resT.tocs.forEach((aToc: any) => {
                        let a_law = decomposeUsernote(aToc);
                        if (a_law) {
                            laws.push(a_law);
                        }
                    });
                    setLawList(laws);
                }
            };
            const decomposeUsernote = (aToc: any) => {
                let lawnumber = aToc.toc_title.split("(")[0];
                let aUsernote = aToc.usernote;
                let lawinfo = aUsernote.split("|");
                let lawtitle = "";
                let lawsubtitle = "";
                let lawtype = "";
                let lawpromulgationdate = "";
                let laweffectdate = "";
                let lawpromulgator = "";
                let lawpromdate = "";
                let lawpyear = null;
                let lawpmonth = null;
                let lawpday = null;
                lawinfo.forEach((unit: any) => {
                    let infounit = unit.split(":");
                    if (infounit[0] === "title") {
                        lawtitle = infounit[1];
                    } else if (infounit[0] === "subtitle") {
                        lawsubtitle = infounit[1];
                    } else if (infounit[0] === "ltype") {
                        lawtype = infounit[1];
                    } else if (infounit[0] === "promdate") {
                        let pdate_info = infounit[1];
                        let pdate_div = pdate_info.split("(");
                        lawpromulgationdate = pdate_div[0];
                        lawpromdate = pdate_div[1].split(")")[0];
                        let pdate_decompose = lawpromdate.split(".");
                        lawpyear = parseInt(pdate_decompose[0]);
                        lawpmonth = parseInt(pdate_decompose[1]);
                        lawpday = parseInt(pdate_decompose[2]);
                    } else if (infounit[0] === "edate") {
                        laweffectdate = infounit[1];
                    } else if (infounit[0] === "promulgator") {
                        lawpromulgator = infounit[1];
                    }
                });
                // find info from bookList with book_id
                let bookinfo = bookList.find((aBook: BookInfo) => {
                    return aBook.book_id === aToc.book_id;
                });
                if (bookinfo !== undefined) {
                    let aLaw: LawInfo = {
                        book_id: aToc.book_id,
                        book_title: bookinfo.book_title,
                        book_number: bookinfo.numeration,
                        toc_id: aToc.toc_id,
                        book_page: aToc.page_start,
                        law_number: lawnumber,
                        law_type: lawtype,
                        law_title: lawtitle,
                        law_subtitle: lawsubtitle,
                        law_promdate: lawpromulgationdate,
                        law_promdate_n: lawpromdate,
                        law_pyear: lawpyear,
                        law_pmonth: lawpmonth,
                        law_pday: lawpday,
                        law_effectdate: laweffectdate,
                        law_promulgator: lawpromulgator,
                    };
                    return aLaw;
                } else {
                    return null;
                }
            };
            resTocs();
        }
    }, [bookList]);

    const [lawYearList, setLawYearList] = React.useState<any[]>([]);
    const [lawYearGroup, setLawYearGroup] = React.useState<any>({});

    React.useEffect(() => {
        if (lawList.length > 0) {
            console.log("lawlist", lawList);
            // sort lawList by  law_promdate_n
            let sortedLawList = lawList.sort((a: LawInfo, b: LawInfo) => {
                if (a.law_promdate_n < b.law_promdate_n) {
                    return -1;
                } else if (a.law_promdate_n > b.law_promdate_n) {
                    return 1;
                } else {
                    return 0;
                }
            });
            setLawList(sortedLawList);
            // group by year
            let yearList: any[] = [];
            let yearGroup: { [key: number]: LawInfo[] } = {};
            lawList.forEach((aLaw: LawInfo) => {
                let year = aLaw.law_pyear;
                if (year !== null && year !== undefined) {
                    if (yearList.indexOf(year) < 0) {
                        yearList.push(year);
                    }
                    if (year in yearGroup) {
                        yearGroup[year].push(aLaw);
                    } else {
                        yearGroup[year] = [aLaw];
                    }
                }
            });
            setLawYearList(yearList);
            setLawYearGroup(yearGroup);

            setLawReady(true);
            setSortFinished(true);
        }
    }, [lawList]);

    const LawYearGroup = () => {
        return (
            <Box
                direction="column"
                width="full"
                height="full"
                overflow={"auto"}
                flex={false}
            >
                {lawYearList.map((year: number, index: number) => {
                    return (
                        <Box key={index} width="full" flex={false}>
                            <LawYearUnit
                                year={year}
                                lawList={lawYearGroup[year]}
                            />
                        </Box>
                    );
                })}
            </Box>
        );
    };
    const LawYearUnit = (props: any) => {
        let year = props.year;
        let lawList = props.lawList;
        return (
            <Box
                direction="row"
                width="96%"
                height="full"
                align="start"
                justify="center"
                margin="10px"
            >
                <Box
                    width="50px"
                    align="center"
                    justify="start"
                    pad={{ top: "5px" }}
                >
                    <Text size="15px" color="white" weight='bold'>
                        {year}
                    </Text>
                </Box>
                <Box
                    width="full"
                    height="full"
                    align="start"
                    justify="start"
                    direction="column"
                    pad="5px"
                >
                    {lawList.map((alaw: LawInfo, index: number) => {
                        return <LawUnit key={index} lawinfo={alaw} />;
                    })}
                </Box>
            </Box>
        );
    };
    const LawUnit = (props: any) => {
        let lawinfo = props.lawinfo;
        return (
            <Box
                border
                background="white"
                margin={{vertical:'1px'}}
                pad={{ horizontal: "20px", top:'5px', bottom:'10px' }}
                width="full"
                align="start"
                justify="start"
                flex={false}
            >
                <Text size="12px" alignSelf="end">
                    {lawinfo.law_type}
                </Text>
                <Text size="16px">{lawinfo.law_title}</Text>
                <Text size="15px" color="grey">
                    {lawinfo.law_number}
                </Text>

                <Text>
                    <Text size="12px" color='grey'>{lawinfo.law_subtitle}</Text>
                </Text>
                <Text>
                    <Text size="12px">공포: {lawinfo.law_promdate}</Text>
                    {lawinfo.law_effectdate.length > 1 && (
                        <Text size="12px">{' '}/ 시행: {lawinfo.law_effectdate}</Text>
                    )}
                </Text>
                <Text size="11px" color="grey" alignSelf='end'>
                   {lawinfo.book_title}, {lawinfo.book_number}
                </Text>
            </Box>
        );
    };

    return (
        <ArchiveCanvas>
            <SectionTitle title="정부자료 / 법률" />
            <MainCanvas>
                <Box
                    direction="column"
                    align="center"
                    justify="start"
                    width="full"
                    height="full"
                >
                    {lawReady && lawList.length > 0 && sortFinished && (
                        <LawYearGroup />
                    )}
                </Box>
            </MainCanvas>
        </ArchiveCanvas>
    );
};
export default LawMain;
